import { t } from "i18next";
import { getURl } from "services/core";
import ImportForm from "common/components/ImportForm";

const url = `${getURl()}/employee/v1/import`;
export default ImportForm({
  title: t("text_import_employees"),
  onBackLink: "/employees",
  titleBeforeUpload: "Are you sure you want to import employees?",
  textBeforeUpload: "This will import for employees. Do you want to continue?",
  textUpload: t("text_upload_a_spreatsheet_to_import_employees"),
  fileName: "Employee Import Employee  Allocated Project Template.xlsx",
  url,
});